
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const AdultBeginnerFAQ = () => {
  const faqs = [
    {
      question: "Er det virkelig muligt at lære klaver som voksen begynder?",
      answer: "Absolut! Det er en myte, at man skal starte som barn for at lære at spille klaver. Voksne har faktisk mange fordele som begyndere, herunder bedre forståelse af koncepter, mere målrettet øvning og klarere musikalske mål. Mange af mine voksne begynderelever opnår imponerende resultater på relativt kort tid."
    },
    {
      question: "Hvor meget tid skal jeg afsætte til øvning hver uge?",
      answer: "Konsistens er vigtigere end mængden. 20-30 minutter 4-5 dage om ugen er meget mere effektivt end én lang øvesession på 3 timer i weekenden. Jeg tilpasser øveanbefalinger til din tidsplan og lærer dig effektive øvemetoder, der giver maksimalt udbytte af den tid, du har til rådighed."
    },
    {
      question: "Skal jeg kunne læse noder for at starte?",
      answer: "Nej, nodelæsning er en færdighed, vi udvikler som en del af undervisningen. Vi begynder ofte med at spille efter gehør og enkle akkordmønstre, mens vi gradvist introducerer nodelæsning. Min tilgang er at give dig praktiske færdigheder fra starten, så du kan opleve glæden ved at spille, samtidig med at du udvikler din musikalske forståelse."
    },
    {
      question: "Hvilket instrument anbefaler du til voksne begyndere?",
      answer: "Ideelt set et klaver med vægtede tangenter, enten akustisk eller digitalt. For voksne begyndere er et digitalt klaver med 88 vægtede tangenter ofte et godt valg, da det giver en realistisk spillefølelse, mulighed for at bruge hovedtelefoner og er mere prisfavorabelt end et akustisk klaver. Jeg kan give specifikke anbefalinger baseret på dit budget og dine mål."
    },
    {
      question: "Kan jeg lære at spille den musik, jeg ønsker?",
      answer: "Mit mål er at hjælpe dig med at spille den musik, du elsker. Vi starter med tilpassede, simplificerede versioner af din foretrukne musik og arbejder gradvist mod mere komplekse arrangementer. Samtidig introducerer jeg teknikker og øvelser, der specifikt understøtter dit repertoirevalg og musikalske præferencer."
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-serif font-bold mb-8 text-center">
            Ofte stillede spørgsmål fra voksne begyndere
          </h2>
          
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left font-medium">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default AdultBeginnerFAQ;
